import './alteration-line.scss'

import _ from 'lodash'
import { first } from 'rxjs/operators'
import Component from "vue-class-component"
import { faTimesCircle, faComment, faImage } from '@fortawesome/free-regular-svg-icons'

import { Alteration, editTranslatedString, getTranslatedString } from '@skinsoft/types'
import { preferredTerm } from '@skinsoft/selectors/thesaurus-term-selectors'
import { ThesaurusTermDataStore } from '@skinsoft/entity'
import { ReactiveVue } from "@skinsoft/reactive-vue"
import { EntitySelect } from '@skinsoft/ui'
import ThesaurusTermTree from '@skinsoft/ui/src/thesaurus-term-tree'
import { THESAURUS_TERM_SELECTED } from '@skinsoft/ui/src/thesaurus-term-tree/thesaurus-term-tree-modal'

export const DELETE_ALTERATION = 'delete-alteration'
export const ALTERATION_EDITED = 'alteration-edited'

export interface AlterationChanged {
    index: number,
    updates: Partial<Alteration>
}

@Component({
    components: {
        sEntitySelect: EntitySelect,
        sThesaurusTermTree: ThesaurusTermTree,
    },
    props: ['alteration', 'index'],
    template: require('./alteration-line.html')
})
export default class AlterationLine extends ReactiveVue {
    
    private alteration: Alteration
    private index: number

    public $thesaurusTermDataStore: ThesaurusTermDataStore

    private selectedAlterationType: string = '' // id of ThesaurusTerm
    private alterationCopy: Alteration | null = null

    public deleteIcon = faTimesCircle
    public commentIcon = faComment
    public imageIcon = faImage

    private DELETE_ALTERATION = DELETE_ALTERATION
    private THESAURUS_TERM_SELECTED = THESAURUS_TERM_SELECTED

    private mounted() {
        if(this.alteration) {
            this.alterationCopy = _.cloneDeep(this.alteration)
            if(this.alteration.typeOfAlteration) {
                this.selectedAlterationType = this.alteration.typeOfAlteration
            }
        }
    }

    private async getThesaurusTermNameIfExists(id: string) {
        if (id) {
            const thesaurusTerm = await this.$thesaurusTermDataStore.fetchOne(id).pipe(first()).toPromise();
            if (thesaurusTerm) {
                return getTranslatedString(
                    preferredTerm(thesaurusTerm),
                    this.$i18n.locale
                )
            }
        }
        return ''
    }

    private onThesaurusTermSelected(thesaurusTermId: string) {
        if(thesaurusTermId) {
            const updates: Partial<Alteration> = {
                typeOfAlteration: thesaurusTermId
            }

            this.selectedAlterationType = thesaurusTermId
            this.$emit(ALTERATION_EDITED, { index: this.index, updates })
        }
    }

    private openPrecisionModal() {
        // @ts-ignore
        this.$refs.precisionModal.show()
    }

    private onAlterationPrecisionEdited() {
        if(this.alterationCopy) {
            const updates: Partial<Alteration> = {
                precision: this.alterationCopy.precision,
            }

            this.$emit(ALTERATION_EDITED, { index: this.index, updates })
        }
        // @ts-ignore
        this.$refs.precisionModal.hide()
    }

    private get precision(): string {
        if(this.alterationCopy) {
            return getTranslatedString(this.alterationCopy.precision, this.$i18n.locale)
        }

        return ''
    }
    private set precision(value: string) {
        if(this.alterationCopy) {
            editTranslatedString(this.alterationCopy.precision, value, this.$i18n.locale)
        }
    }

    private get title(): string {
        if(this.alterationCopy) {
            return getTranslatedString(this.alterationCopy.title, this.$i18n.locale)
        }

        return ''
    }
    private set title(value: string) {
        if(this.alterationCopy) {
            editTranslatedString(this.alterationCopy.title, value, this.$i18n.locale)

            const updates: Partial<Alteration> = {
                title: this.alterationCopy.title,
            }
            this.$emit(ALTERATION_EDITED, { index: this.index, updates })
        }
    }
}